var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoratorTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 499,
    height: 323,
    viewBox: "0 0 499 323",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-36.3653 321.852L179.345 285.388L303.352 264.428C368.313 253.449 421.844 220.019 456.214 174.822C490.583 129.624 505.798 72.6638 493.618 14.4967C491.532 5.68232 481.548 0.0710334 471.693 1.74223L255.983 38.2069L131.976 59.1665C67.0146 70.1454 13.4841 103.575 -20.8855 148.773C-55.2551 193.971 -70.4637 250.931 -58.2903 309.098C-56.2044 317.912 -46.2203 323.524 -36.3718 321.858L-36.3653 321.852Z",
    stroke: "#E5EDF9",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoratorTwo);
export default __webpack_public_path__ + "static/media/decorator-two.793bb8760b7f28f75c62e699f1a95d5b.svg";
export { ForwardRef as ReactComponent };